import Home from '../pages/Home.vue'
//管理员管理
import Adminlist from '../pages/admin/index.vue'
import Addminupdte from '../pages/admin/updte.vue'
import Addminadd from '../pages/admin/add.vue'
import Adminlog from '../pages/admin/Adminlog.vue'
//角色管理
import Rolelist from '../pages/role/index.vue'
import Roleupdte from '../pages/role/updte.vue'
import Roleadd from '../pages/role/add.vue'
//集团管理
import Companylist from '../pages/admin/index.vue'
import Companyupdte from '../pages/company/updte.vue'
import Companyadd from '../pages/company/add.vue'
import Companyadmin from '../pages/company/adminlist.vue'
//权限管理
import platform_privilegeslist from '../pages/privileges/index.vue'
import platformadd from '../pages/privileges/platformadd.vue'
import platformupdte from '../pages/privileges/platformupdte.vue'
import aprtmentindex from '../pages/privileges/aprtmentindex.vue'
import aprtmentadd from '../pages/privileges/aprtmentadd.vue'
import aprtmentupdte from '../pages/privileges/aprtmentupdte.vue'
import companyindex from '../pages/privileges/companyindex.vue'
import companyadd from '../pages/privileges/companyadd.vue'
import companyupdte from '../pages/privileges/companyupdte.vue'
import hotelindex from '../pages/privileges/hotelindex.vue'
import hoteladd from '../pages/privileges/hoteladd.vue'
import hotelupdte from '../pages/privileges/hotelupdte.vue'
//菜单管理
import menulist from '../pages/menu/index.vue'
import hotel_menu from '../pages/menu/hotel_menu.vue'
import company_menu from '../pages/menu/company_menu.vue'
//系统设置
import paymethodindex from '../pages/System/paymethodindex.vue'
import paymethodcompany from '../pages/System/paymethodcompany.vue'
import setting from '../pages/System/setting.vue'

export default{
  Home ,
  Adminlist,
  Addminupdte, 
  Addminadd ,
  Adminlog,
//角色管理
 Rolelist ,
 Roleupdte ,
 Roleadd ,
//集团管理
 Companylist ,
 Companyupdte,
 Companyadd ,
 Companyadmin ,
//权限管理
 platform_privilegeslist ,
 platformadd ,
 platformupdte ,
 aprtmentindex ,
 aprtmentadd ,
 aprtmentupdte ,
 companyindex ,
 companyadd ,
 companyupdte ,
 hotelindex ,
 hoteladd ,
 hotelupdte ,
//菜单管理
 menulist ,
 hotel_menu ,
 company_menu ,
//系统设置
 paymethodindex ,
 paymethodcompany ,
 setting,
}


// WEBPACK FOOTER //
// ./src/constant/component.js